import { callable } from '.';

import {
  IssueTokenParams,
  IssueTokenResponse,
} from 'functions/src/callable/moralis/issueToken.f';

export type { IssueTokenParams, IssueTokenResponse };

export const issueToken = callable<IssueTokenParams, IssueTokenResponse>(
  'issueToken',
);
